module.exports = __webpack_public_path__ + "static/media/planet-avatar-02.7cb62a72.png";